<template>
  <div class="l-home__locale__wrapper">
    <div
      class="l-home__navbar__locale primary-bg"
      @click="localeOpen = !localeOpen"
    >
      <span class="l-home__navbar__locale__text">{{
        locale.toUpperCase()
      }}</span>
      <i
        class="fas fa-chevron-down l-home__navbar__locale__icon"
        :class="{ localeOpen: !localeOpen }"
      ></i>
    </div>
    <div
      class="l-home__navbar__locale--expanded"
      :class="{
        'd-none l-home__navbar__locale--expanded': !localeOpen
      }"
    >
      <div
        class="l-home__dropdown__item"
        v-for="lang in locales"
        :key="lang"
        @click="handleChangeLocale(lang)"
      >
        {{ lang.toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
import { getLocale, changeLocale } from "@/i18n.js";

export default {
  name: "locale-changer",
  data() {
    return {
      locale: getLocale(),
      locales: this.generateLocales(),
      localeOpen: false
    };
  },
  methods: {
    generateLocales() {
      const activeLocale = getLocale();
      this.locale = activeLocale;
      const locales = this.$store.state.campaign.accept_languages;
      return locales.filter(item => item != activeLocale);
    },
    async handleChangeLocale(locale) {
      this.locale = locale;
      const locales = this.$store.state.campaign.accept_languages;
      this.locales = locales.filter(item => item != locale);
      this.localeOpen = !this.localeOpen;
      await changeLocale(locale);
    }
  }
};
</script>

<style lang="scss" scoped+>
.l-home__navbar__locale {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  // background-color: #ff276f;
  color: white;
  width: 4rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  position: relative;
}
.l-home__navbar__locale__text {
  margin-right: 0.3rem;
}
.l-home__navbar__locale__icon {
  transition: transform 0.3s;
  transform: rotate(180deg);
}
.l-home__locale__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.l-home__navbar__locale--expanded {
  transition: height 0.5 transform 0.5s;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 58px;
  z-index: 99;
}
.localeOpen {
  transition: transform 0.3s;
  transform: rotate(360deg);
}
.l-home__dropdown__item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 1rem;
  padding: 0rem 1rem;
  border-radius: 25px;
  background-color: rgba(255, 255, 255, 0.8);
  color: black;
  width: 4rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.l-home__dropdown__item:hover {
  background-color: white;
}
</style>
